import { authRequest } from "src/engine/modules/authRequest"

// Спека https://next.stoplight.io/infotech-group/planner/version%2F1.0/main.oas2.yml?view=%2Fresourcetypefields%2Fcreateresourcetypefield

export const getFields = ({
  rtid,
  query: { limit, offset, orderBy, query },
} = {}) =>
  authRequest({
    url: `/resources/types/${rtid}/fields`,
    params: {
      orderBy,
      offset,
      limit,
      query,
    },
  })
export const getField = id =>
  authRequest({ url: `/resources/types/fields/${id}` })

export const createField = props => {
  const { rtid, data } = props
  return authRequest({
    url: `/resources/types/${rtid}/fields`,
    method: `post`,
    data,
  })
}
export const updateField = props => {
  const { id, data } = props
  return authRequest({
    url: `/resources/types/fields/${id}`,
    method: `put`,
    data,
  })
}

export const removeField = id =>
  authRequest({
    url: `/resources/types/fields/${id}`,
    method: `delete`,
  })
